import { render, staticRenderFns } from "./TableGroup.vue?vue&type=template&id=1c2521b7&scoped=true"
import script from "./TableGroup.vue?vue&type=script&lang=js"
export * from "./TableGroup.vue?vue&type=script&lang=js"
import style0 from "./TableGroup.vue?vue&type=style&index=0&id=1c2521b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2521b7",
  null
  
)

export default component.exports